import React from "react";
import { Button, Tooltip, Typography } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import { Interview } from "../../../../Entities/Interview";
import dayjs from "dayjs";
import { openNotification } from "../../../../Components/Notification";

interface JobApplicationScheduledInterviewHeaderProps {
  scheduledInterview: Interview;
}

const JobApplicationScheduledInterviewHeader: React.FC<
  JobApplicationScheduledInterviewHeaderProps
> = ({ scheduledInterview }) => {
  const { conferenceId, startTime } = scheduledInterview;

  const isExpired = dayjs(startTime).isBefore(dayjs());

  const handleStartInterview = () => {
    if (isExpired) {
      openNotification(
        "error",
        "Interview Meeting Link Expired",
        "The interview meeting link has already expired."
      );
      return;
    }
    const path: string = `https://meet.google.com/${conferenceId}`;
    window.location.href = path;
  };

  return (
    <div className="job-application-scheduled-interview-header-container">
      <div>
        <Typography.Title level={5} style={{ margin: 0 }}>
          Scheduled Interview
        </Typography.Title>
        <Typography.Text type="secondary">
          View the scheduled <strong>interview</strong> details for this job
          application
        </Typography.Text>
      </div>
      <Tooltip
        title={isExpired ? "Interview Meeting Link Expired" : "Start Interview"}
      >
        <Button
          type="default"
          icon={<PlayCircleOutlined />}
          onClick={handleStartInterview}
          disabled={isExpired}
        >
          Start Interview
        </Button>
      </Tooltip>
    </div>
  );
};

export default JobApplicationScheduledInterviewHeader;
